import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Skip interceptor for Keycloak endpoints
  if (req.url.includes('/realms/') || req.url.includes('/protocol/openid-connect')) {
    return next(req);
  }

  // Get token from AuthService (not localStorage directly)
  const authToken = authService.getAccessToken();

  // Clone request and add Authorization header if token exists
  let authReq = req;
  if (authToken) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${authToken}`
      }
    });
  }

  return next(authReq).pipe(
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        switch (err.status) {
          case 401:
            // Unauthorized - token expired or invalid
            console.error('Unauthorized request (401):', err);
            console.warn('Token möglicherweise abgelaufen. Weiterleitung zum Login...');

            // Clear token and redirect to login
            localStorage.removeItem('authToken');
            authService.login(router.url);
            break;

          case 403:
            // Forbidden - user doesn't have permission
            console.error('Forbidden request (403):', err);
            console.warn('Keine Berechtigung für diese Ressource.');
            router.navigate(['/unauthorized']);
            break;

          case 404:
            // Not found
            console.error('Resource not found (404):', err);
            break;

          case 500:
            // Server error
            console.error('Server error (500):', err);
            break;

          default:
            console.error('HTTP error:', err.status, err.message);
        }
      } else {
        // Handle non-HTTP errors
        console.error('An error occurred:', err);
      }

      // Re-throw the error to propagate it further
      return throwError(() => err);
    })
  );
};
